import SessionTimeout from './SessionTimeout'

export default SessionTimeout
